import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {Box, TextField} from "@mui/material";
import Loading from "../../../../../ui/Loading";
import {CustomAxiosError} from "../../../../../../logics/api_config";
import {useToast} from "../../../../../../utils/contexts/toast-context";
import MuiAutocomplete from "../../../../../ui/mui/mui-input/MuiAutoComplete";
import {
    ISpecialMonthEnds
} from "../../../../../../utils/interfaces/my_documents/fiscal_registry/payment/ISpecialMonthEnds";
import useApiGetSpecialMonthEndss from "./api-hooks/useApiGetSpecialMonthEndss";
import useApiGetSpecialMonthEnds from "./api-hooks/useApiGetSpecialMonthEnds";


interface Props {
    obj: ISpecialMonthEnds | undefined,
    onChange: (obj: ISpecialMonthEnds | undefined) => void,
    className: string,
    label?: string,
    required?: boolean
}

const SpecialMonthEndsSelect = ({
                                    obj: initialObj,
                                    label,
                                    onChange,
                                    required,
                                }: Props) => {

    const {displayError} = useToast()
    const {t} = useTranslation()


    const [objs, setObjs] = useState<ISpecialMonthEnds[]>([]);
    const [obj, setObj] = useState<ISpecialMonthEnds | undefined>(initialObj)


    useEffect(() => {
        setObj(undefined);
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj]);


    const {
        data,
        isLoading,
        error,
    } = useApiGetSpecialMonthEndss();
    if (error) {
        const axiosError = error as CustomAxiosError;
        displayError(axiosError.response.data.detail);
    }


    useEffect(() => {
        if (data) {
            setObjs(data)
        }
    }, [data]);


    const {
        data: detailedObj,
    } = useApiGetSpecialMonthEnds(obj?.id);

    useEffect(() => {
        if (detailedObj) {
            setObj(detailedObj);
        }
    }, [detailedObj]);

    const handleOnChange = (event: React.SyntheticEvent, newValue: ISpecialMonthEnds | null) => {
        if (newValue) {
            onChange(newValue);
        } else {
            onChange(undefined);
        }
    };

    useEffect(() => {
        onChange(obj);
    }, [obj]);


    return (
        <>
            {isLoading ? (
                <Loading/>
            ) : (
                <>
                    <Box sx={{alignItems: 'center', width: '100%'}}>
                        <MuiAutocomplete
                            id="special_month_ends-select"
                            options={objs}
                            getOptionLabel={(option) => t(option.name)}
                            value={detailedObj ? detailedObj : null}
                            onChange={handleOnChange}
                            isOptionEqualToValue={(option, value) => option.id === value?.id && option.code === value?.code}
                            disableClearable={true}
                            renderInput={(params) => (
                                <TextField
                                    sx={{textTransform: 'capitalize'}}
                                    {...params}
                                    label={label ? t(label) : '' || t('special_month_ends')}
                                    required={required}
                                />
                            )}
                        />
                    </Box>
                </>
            )}
        </>
    );
}

export default SpecialMonthEndsSelect;